import { QuantityButton } from '~/mappers/quantityButton/models';

export const quantityButtonMapper = ({
  increaseAriaLabel,
  decreaseAriaLabel,
  inputAriaLabel,
  maxQuantityOfProducts,
  minQuantityOfProducts,
  maxLimitErrorMessage,
  minLimitErrorMessage,
  id,
  quantityLabel,
}: QuantityButton) => ({
  increaseAriaLabel,
  decreaseAriaLabel,
  inputAriaLabel,
  max: Number(maxQuantityOfProducts) || undefined,
  min: Number(minQuantityOfProducts) || undefined,
  errorMessage: {
    maxLimitErrorMessage,
    minLimitErrorMessage,
  },
  id,
  label: quantityLabel,
});
